export function getSelectedProject() {
  const project = localStorage.getItem('selected-project');
  //project.classList.add('menusList');
  if (project) {
    return JSON.parse(project);
  } else {
    return { id: 'all', name: 'All Projects' };
  }
}
